import { useEffect, useMemo } from 'react';

import { FCC } from '@eluve/components';
import { useIsOnline, usePrevious } from '@eluve/utility-hooks';

import { TaskProcessorInterface } from './types';
import { TaskProcessorProviderContext } from './useTaskProcessor';

export interface TaskProcessorContextValue {
  taskProcessor: TaskProcessorInterface;
}

export const TaskProcessorProvider: FCC<{
  taskProcessor: TaskProcessorInterface;
}> = ({ children, taskProcessor }) => {
  const isOnline = useIsOnline();
  const wasOnline = usePrevious(isOnline);

  useEffect(() => {
    const processTasksIfOnline = async () => {
      try {
        if (taskProcessor.isInitialized) {
          taskProcessor.resume();
        } else {
          await taskProcessor.initialize();
        }
      } catch {
        /* ignore */
      }
    };

    const pauseTaskQueue = () => {
      taskProcessor.pause();
    };

    if (isOnline) {
      processTasksIfOnline();
    } else if (wasOnline === true) {
      pauseTaskQueue();
    }
  }, [isOnline, wasOnline, taskProcessor]);

  const value = useMemo(() => ({ taskProcessor }), [taskProcessor]);

  return (
    <TaskProcessorProviderContext.Provider value={value}>
      {children}
    </TaskProcessorProviderContext.Provider>
  );
};
